export const version = "1.0.2-daily-20260327-0";
export const channel = "daily";
export const gitcommit = "8f8fa177a";
